import React from 'react';
import Wrapper from '../Wrapper';
import SearchAcrossSectionsContainer from './SearchAcrossSectionsContainer/SearchAcrossSectionsContainer';

const SearchAcrossSectionsContainerWrapper = (props) => {
  return (
    <Wrapper profilerId="SearchAcrossSections" {...props}>
      <SearchAcrossSectionsContainer {...props} />
    </Wrapper>
  );
};

export default SearchAcrossSectionsContainerWrapper;
